import { useEffect, useRef } from 'react';
import { useCountUp } from '@/hooks/useCountUp';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import './OfferCountBadge.scss';

interface OfferCountBadgeProps {
  count: number;
}

export function OfferCountBadge({ count }: OfferCountBadgeProps) {
  const { ref, isIntersecting } = useIntersectionObserver<HTMLSpanElement>({
    threshold: 0.5,
    triggerOnce: true,
  });
  const { value, start } = useCountUp(count, { duration: 1500 });
  const hasStartedRef = useRef(false);

  // Start animation when element enters viewport for the first time.
  // Re-animation when count changes afterwards is handled by useCountUp itself.
  useEffect(() => {
    if (isIntersecting && !hasStartedRef.current) {
      hasStartedRef.current = true;
      start();
    }
  }, [isIntersecting, count, start]);

  return (
    <span ref={ref} className="offer-count-badge">
      <span className="offer-count-badge__number">{value}</span>
      <span className="offer-count-badge__label">{value <= 1 ? 'offre' : 'offres'}</span>
    </span>
  );
}

export default OfferCountBadge;
